import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('@/pages/home/page'));
const Knowledge = lazy(() => import('@/pages/knowledge/page'));
const Policy = lazy(() => import('@/pages/policy/page'));
const Resources = lazy(() => import('@/pages/resources/page'));
const Digital = lazy(() => import('@/pages/digital/page'));
const Global = lazy(() => import('@/pages/global/page'));
const NotFound = lazy(() => import('@/pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/knowledge',
    element: <Knowledge />,
  },
  {
    path: '/policy',
    element: <Policy />,
  },
  {
    path: '/resources',
    element: <Resources />,
  },
  {
    path: '/digital',
    element: <Digital />,
  },
  {
    path: '/global',
    element: <Global />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
